// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qi-9";
export var arrowButtonContainer = "_qi-5";
export var arrowButtonIcon = "_qi-6";
export var carouselArrowButton = "_qi-2";
export var carouselElementContainer = "_qi-1";
export var currentSlide = "_qi-8";
export var left = "_qi-3";
export var otherSlide = "_qi-a";
export var productCarouselContainer = "_qi-0";
export var right = "_qi-4";
export var sliderOverflow = "_qi-7";